import axios from 'axios';
import '../App.css';
import Banner from '../components/Banner';
import ProgressBar from '../components/ProgressBar';
import { useNavigate } from 'react-router-dom';
import { useState, useEffect, useCallback } from 'react';
import Loading from '../components/Loading';
import TitleComponent from '../components/TitleComponent';
import { useSearchParams } from 'react-router-dom';
import Footer from '../components/Footer';

function Order() {
    const [searchParams, setSearchParams] = useSearchParams();
    const [completed, setCompleted] = useState(0);
    const [isInitialLoading, setIsInitialLoading] = useState(true);
    const userId = searchParams.get('userId');
    const secretKey = searchParams.get('secretKey');

    const [status, setStatus] = useState({
        cStatus: '',
        name: '',
        createDatetime: '',
        startDatetime: '',
        endDatetime: '',
        kind: '',
        paid: '',
        price: '',
        receipt: '',
    });
    const [concepts, setConcepts] = useState([]);

    let navigate = useNavigate();

    const routeChange = (isInternal, path, e) => {
        e.preventDefault();
        if (isInternal) {
            let newPath = path;
            navigate(newPath);
        } else {
            window.open(path);
        }
    };

    const getStatus = useCallback(
        (isInitial = false) => {
            let url = `${process.env.REACT_APP_API_ADDRESS}/users/${userId}`;

            axios
                .get(url)
                .then((res) => {
                    setStatus(res.data);
                    // concept를 ,로 분리
                    if (res.data.concept) {
                        const conceptArray = res.data.concept
                            .split(',')
                            .map((c) => c.trim());
                        setConcepts(conceptArray);
                    }
                    if (isInitial) {
                        setIsInitialLoading(false);
                    }
                })
                .catch((error) => {
                    console.log(error.response.data);
                    if (isInitial) {
                        setIsInitialLoading(false);
                    }
                });
        },
        [userId]
    );

    useEffect(() => {
        getStatus(true);
    }, [getStatus]);

    // modelVersion='2'일 때 10초마다 폴링
    useEffect(() => {
        // 폴링 조건: modelVersion='2' && (cStatus='0'(대기중) || cStatus='1'(진행중))
        if (
            status.modelVersion === '2' &&
            (status.cStatus === '0' || status.cStatus === '1')
        ) {
            const intervalId = setInterval(() => {
                getStatus();
            }, 10000); // 10초

            // cleanup: 컴포넌트 언마운트 시 또는 조건 변경 시 interval 정리
            return () => {
                clearInterval(intervalId);
            };
        }
    }, [status.modelVersion, status.cStatus, getStatus]);

    useEffect(() => {
        setCompleted(getProgressValue());
    }, [status]);

    const getProgressValue = () => {
        if (status.startDatetime != '') {
            let startDatetime = status.startDatetime;
            // make utc 0 time to korea time

            startDatetime = new Date(startDatetime);
            startDatetime.setHours(startDatetime.getHours() + 9);

            // modelVersion에 따라 예상 시간 다르게 설정
            let estimatedMinutes;
            if (status.modelVersion === '2') {
                // concept 개수 × 1분
                const conceptCount = concepts.length || 1;
                estimatedMinutes = conceptCount * 1;
            } else {
                estimatedMinutes = 40;
            }

            // let eta = startdate time plus estimated mins
            let eta = new Date(startDatetime);
            eta.setMinutes(eta.getMinutes() + estimatedMinutes);

            // get current time
            let now = new Date();

            // get ratio between eta and startdatetime (0~1)
            // make datetime to timestamp
            startDatetime = startDatetime.getTime();
            eta = eta.getTime();
            now = now.getTime();

            let ratio = (now - startDatetime) / (eta - startDatetime);

            if (status.cStatus === '1') {
                // if ratio is bigger than 1, set it to 0.99
                if (ratio > 1) {
                    ratio = 0.99;
                } else if (ratio < 0) {
                    ratio = 0;
                }
            } else if (status.cStatus === '2') {
                ratio = 1.0;
            } else if (status.cStatus === '3') {
                ratio = 0;
            } else if (status.cStatus === '5') {
                ratio = 1;
            }
            // drop decimal point
            return Math.floor(ratio * 100);
        } else {
            return 0;
        }
    };

    const changeDatetimeToString = (datetime) => {
        if (datetime === '') return datetime;

        let date = new Date(datetime);
        date.setHours(date.getHours() + 9);
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();
        let hour = date.getHours();
        let min = date.getMinutes();

        let dateString = `${year}년 ${month}월 ${day}일 ${hour}시 ${min}분`;
        return dateString;
    };

    const statusDiv = () => {
        return (
            <>
                <div>
                    <div className="info-title">진행 상태</div>
                    {status.cStatus === '1' ? (
                        <div
                            className="info-title"
                            style={{ margin: '20px 0 0 0 ' }}
                        >
                            그림이 아직 완성되지 않았습니다. 조금만 더
                            기다려주세요.
                            <br />
                            {status.modelVersion === '2'
                                ? `(약 ${concepts.length * 1}분 소요 예정)`
                                : '(약 40분 ~ 1시간 소요 예정)'}
                        </div>
                    ) : null}

                    {/* todo: cStatus 값에 따른 0~100 사이의 값 추가 */}
                    <ProgressBar bgcolor={'#ff7b07'} completed={completed} />

                    <div className="justify-content-space-between">
                        <div className="info-title">결제 완료 시간</div>
                        <div className="info-title">
                            {changeDatetimeToString(status.createDatetime)}
                        </div>
                    </div>
                    <div className="justify-content-space-between">
                        <div className="info-title">그림 생성 시작 시간</div>
                        <div className="info-title">
                            {status.startDatetime.length
                                ? changeDatetimeToString(status.startDatetime)
                                : '아직 시작되지 않았습니다'}
                        </div>
                    </div>

                    {status.cStatus === '2' ? (
                        <div>
                            <div className="justify-content-space-between">
                                <div className="info-title">
                                    그림 생성 완료 시간
                                </div>
                                <div className="info-title">
                                    {changeDatetimeToString(status.endDatetime)}
                                </div>
                            </div>

                            <div className="right-align-button">
                                <div
                                    className="white-button"
                                    style={{
                                        fontSize: '15px',
                                        marginRight: '0',
                                    }}
                                    onClick={(e) => {
                                        routeChange(
                                            true,
                                            `/see?userId=${userId}&secretKey=${secretKey}`,
                                            e
                                        );
                                    }}
                                >
                                    완성된 그림 보러가기
                                </div>
                            </div>
                        </div>
                    ) : null}
                </div>
            </>
        );
    };

    const infoDiv = () => {
        const conceptLabels = {
            studio: '스튜디오',
            job: '직업',
            season: '시즌',
            trip: '여행',
            'water-paint': '수채화',
            'oil-paint': '유화',
        };

        return (
            <>
                <div>
                    <div className="justify-content-space-between">
                        <div className="info-title">대상 이름</div>
                        <div className="info-content">{status.name}</div>
                    </div>
                    <div className="justify-content-space-between">
                        <div className="info-title">대상 종</div>
                        <div className="info-content">
                            {status.kind.includes(' dog') ||
                            status.kind === 'dog'
                                ? '강아지'
                                : status.kind.includes(' cat') ||
                                  status.kind === 'cat'
                                ? '고양이'
                                : '오류'}
                        </div>
                    </div>
                    {status.modelVersion === '2' && concepts.length > 0 && (
                        <div className="justify-content-space-between">
                            <div className="info-title">선택된 컨셉</div>
                            <div className="info-content">
                                {concepts
                                    .map(
                                        (concept) =>
                                            conceptLabels[concept] || concept
                                    )
                                    .join(', ')}
                            </div>
                        </div>
                    )}
                    <div className="justify-content-space-between">
                        <div className="info-title">결제 여부</div>
                        <div className="info-content">
                            {status.paid ? (
                                <span>결제 완료</span>
                            ) : (
                                <span style={{ color: '#DC4E4E' }}>
                                    결제 미완료
                                </span>
                            )}
                        </div>
                    </div>

                    {status.paid && status.type !== 'offline' ? (
                        <>
                            {Number(status.price) > 0 && (
                                <>
                                    <div className="justify-content-space-between">
                                        <div className="info-title">결제 금액</div>
                                        <div className="info-content">
                                            {status.price}원
                                        </div>
                                    </div>
                                    {status.receipt && (
                                        <div className="justify-content-space-between">
                                            <div className="info-title">결제 영수증</div>
                                            <div className="info-content">
                                                <div
                                                    className="white-button"
                                                    style={{
                                                        fontSize: '15px',
                                                        marginRight: '0',
                                                    }}
                                                    onClick={(e) => {
                                                        routeChange(
                                                            false,
                                                            status.receipt,
                                                            e
                                                        );
                                                    }}
                                                >
                                                    영수증
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </>
                            )}
                            {status.cStatus === '5' ? (
                                <div style={{ marginTop: '20px' }}>
                                    <div className="justify-content-space-between">
                                        <div className="info-title">
                                            영구삭제된 컬렉션입니다.
                                        </div>
                                    </div>
                                </div>
                            ) : null}
                        </>
                    ) : null}
                </div>
            </>
        );
    };

    const subtitleDiv = () => {
        return (
            <>
                레이몽을 이용해주셔서 감사합니다
                <br />
                현재 사진을 해석하고 그림을 생성 중 입니다. 진행 상태를
                확인하세요
            </>
        );
    };

    return (
        <div>
            {isInitialLoading ? (
                <Loading />
            ) : (
                <div className="app ">
                    <div className="border-padding">
                        <TitleComponent subtitle={subtitleDiv()} />

                        <div className="page-content">
                            <Banner
                                bannerTitle={'INFO'}
                                contentDiv={infoDiv()}
                            />
                            <Banner
                                bannerTitle={'STATUS'}
                                contentDiv={statusDiv()}
                            />
                        </div>
                    </div>

                    <Footer />
                </div>
            )}
        </div>
    );
}

export default Order;
